import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, Home } from 'lucide-react';
import AppMenu from '../components/AppMenu';
import AppFooter from '../components/AppFooter';

const REDIRECT_SECONDS = 3;

export default function ThanksPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const caseNumber = state && typeof state.caseNumber === 'number' ? state.caseNumber : null;
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (countdown <= 0) {
      navigate('/');
      return;
    }
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <AppMenu />
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="flex justify-center mb-6">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <h1 className="text-3xl font-black text-primary mb-3">Tack för din förfrågan!</h1>
          <p className="text-muted-foreground text-base mb-2">
            Vi kontaktar dig inom kort för att bekräfta din offert.
            {caseNumber != null ? (
              <span className="block mt-2 text-sm font-medium text-primary">Ärendenummer #{caseNumber}</span>
            ) : null}
          </p>
          <p className="text-sm text-muted-foreground mb-8">
            Du omdirigeras till startsidan om {countdown} sekund{countdown !== 1 ? 'er' : ''}...
          </p>
          <Button
            onClick={() => navigate('/')}
            className="bg-[#374ef4] hover:bg-[#2a3fd4] text-white font-bold"
            size="lg"
          >
            <Home className="mr-2 h-4 w-4" />
            Tillbaka till start
          </Button>
        </div>
      </main>
      <AppFooter />
    </div>
  );
}
